<template>

    <v-action name="Border Width">
        <div class="inputs">
            <div class="input">
                <span>Top</span>
                <v-input-numeric :model="model('border_top_width')" :tabindex="tabindex" :min="0" :max="max" @input="onInputTop" />
            </div>
            <div class="input">
                <span>Bottom</span>
                <v-input-numeric :model="model('border_bottom_width')" :tabindex="tabindex + 1" :min="0" :max="max" @input="onInputBottom" />
            </div>
            <div class="input">
                <span>Left</span>
                <v-input-numeric :model="model('border_left_width')" :tabindex="tabindex + 2" :min="0" :max="max" @input="onInputLeft" />
            </div>
            <div class="input">
                <span>Right</span>
                <v-input-numeric :model="model('border_right_width')" :tabindex="tabindex + 3" :min="0" :max="max" @input="onInputRight" />
            </div>
        </div>
    </v-action>

</template>

<style scoped lang="scss">

    .inputs {
        display: grid;
        grid-gap: 10px;
        grid-template-columns: 1fr 1fr;
        span {
            @include font-medium(11px);
            color: $color-muted;
            display: block;
            margin-bottom: 5px;
            user-select: none;
        }
    }

</style>

<script>

import Action from './Action';

export default {

    components: {
        'v-action': Action,
    },

    props: {
        container: {
            type: Boolean,
            default: false,
        },
        tabindex: {
            type: Number,
            default: 1,
        },
        max: {
            type: Number,
            default: 1000,
        },
    },

    computed: {

        block() {
            return this.$store.getters['builder/selectedBlock'];
        },

    },

    methods: {

        model(key) {
            if (!this.container) {
                return parseInt(this.block[key].replace(/\D/g, '') || 0);
            } else {
                return parseInt(this.block['container'][key].replace(/\D/g, '') || 0);
            }
        },

        onInputTop(val) {
            let block = this.block;
            if (!this.container) {
                block['border_top_width'] = val + 'px';
            } else {
                block['container']['border_top_width'] = val + 'px';
            }
            this.$store.commit('builder/setSelectedBlock', block);
        },

        onInputBottom(val) {
            let block = this.block;
            if (!this.container) {
                block['border_bottom_width'] = val + 'px';
            } else {
                block['container']['border_bottom_width'] = val + 'px';
            }
            this.$store.commit('builder/setSelectedBlock', block);
        },

        onInputLeft(val) {
            let block = this.block;
            if (!this.container) {
                block['border_left_width'] = val + 'px';
            } else {
                block['container']['border_left_width'] = val + 'px';
            }
            this.$store.commit('builder/setSelectedBlock', block);
        },

        onInputRight(val) {
            let block = this.block;
            if (!this.container) {
                block['border_right_width'] = val + 'px';
            } else {
                block['container']['border_right_width'] = val + 'px';
            }
            this.$store.commit('builder/setSelectedBlock', block);
        },

    },

}

</script>